export const GUTTER_SPACING = 48;
export const NAV_MAIN_SECTION_HEIGHT = 60;
export const DESKTOP_TOP_HEIGHT = 36;
export const HOST_NAME = process.env.HOST_NAME;
export const SITE_HOST_NIKE = `https://${HOST_NAME}`;
export const MODIFIER_IS_OPEN = 'is--open';
export const IS_FOCUSSED = 'is-focussed';
export const IS_STANDALONE_LINK = 'is-standalone-link';
export const SCROLLING_DOWN = 'scrolling down';
export const SCROLLING_UP = 'scrolling up';
export const SCROLL = 'scroll';
export const DEBOUNCE_DELAY = 200;
export const MAX_SUGGESTIONS_COUNT = 4;
export const LOG_OUT_BUTTON_PATH = 'my account:log out';
export const MAX_RESULTS_COUNT = 6;
export const MAX_RESULTS_COUNT_DESKTOP = 5;
export const IMAGE_BASE_URL = `https://${process.env.IMAGE_BASE_URL}/is/image/DotCom`;
export const SIZING_QUERY = '?$NIKE_PWP_GRAY$&hei=200&wid=200&align=0,.25';
export const SIZING_QUERY_V2 = '?$NIKE_PWP_GRAY$&hei=400&wid=320&align=0,.25';
export const ASPECT_RATIO = {
  PORTRAIT: 'portrait',
  SQUARE: 'square',
};

export const BOLD_PRIVACY_FOOTER_LINK = 'BOLD_PRIVACY_FOOTER_LINK';
export const COOKIE_MODAL_REJECT_ALL = 'COOKIE_MODAL_REJECT_ALL';
export const COOKIE_SETTINGS = 'COOKIE_SETTINGS';
export const PEEK_A_BOO_NAV = 'PEEKABOO_NAV';
export const GLOBAL_NAV_CART = 'GLOBAL_NAV_CART';
export const GLOBAL_NAV_FAVORITES = 'GLOBAL_NAV_FAVORITES';
export const GLOBAL_NAV_SEARCH = 'GLOBAL_NAV_SEARCH';
export const PULSE_INSIGHTS = 'PULSE_INSIGHTS';
export const GLOBAL_NAV_LANGUAGE_TUNNEL = 'GLOBAL_NAV_LANGUAGE_TUNNEL';
export const GLOBAL_NAV_FIND_A_STORE = 'GLOBAL_NAV_FIND_A_STORE';
export const GLOBAL_NAV_KOREAN_FOOTER = 'GLOBAL_NAV_KOREAN_FOOTER';
export const GLOBAL_NAV_KOREAN_FULL_NAME = 'GLOBAL_NAV_KOREAN_FULL_NAME';
export const SEARCH_WITH_ONE_CHAR = 'SEARCH_WITH_ONE_CHAR';
export const SHOW_GEOMISMATCH = 'SHOW_GEOMISMATCH';
export const TYPE_AHEAD = 'TYPE_AHEAD';
export const POPULAR_SEARCH_TERMS_FLAG = 'POPULAR_SEARCH_TERMS';
export const GLOBAL_NAV_MENU = 'GLOBAL_NAV_MENU';
export const GLOBAL_NAV_MOBILE_ORDERS = 'GLOBAL_NAV_MOBILE_ORDERS';
export const HIDE_ENGLISH_GEOMISMATCH = 'HIDE_ENGLISH_GEOMISMATCH';
export const SKIP_TO_A11Y = 'SKIP_TO_A11Y';
export const NIKE_AI = 'NIKE_AI';

export const TARCE_KEY = 'pre';
export const TARCE_PROP = `$${TARCE_KEY}`;
export const DEFAULT_JORDAN_LINK = `https://${HOST_NAME}/jordan`;

export const REMINDER_DELAY = 5000;

export const MENU_TYPES = {
  MAIN_MENU: 'main-menu',
  BRAND_MENU: 'brand-menu',
  HELP_MENU: 'help-menu',
  ACCOUNT_SETTINGS_MENU: 'account-settings',
  BOTTOM_FOOTER: 'bottom-footer',
  MAIN_FOOTER: 'main-footer',
};

export const DATA_TYPES = {
  HEADER: 'header',
  FOOTER: 'footer',
};

export const FOOTER_DIV_ID = 'gen-nav-footer';
export const HEADER_DIV_ID = 'gen-nav-commerce-header-v2';
export const offPlatformCountries = [
  'AR',
  'BR',
  'CO',
  'HK',
  'CL',
  'PE',
  'QA',
  'KW',
  'SA',
  'AE',
  'UY',
];

export const URL = {
  BASE: `https://${process.env.HOST_NAME}`,
  ASSETS_PROD: `https://${process.env.HOST_NAME}/assets`,
  ASSETS_TEST: `https://assets.test.commerce.${process.env.NIKECLOUD_DOMAIN}`,
  API_SEARCH: `https://${process.env.API_HOST_NAME}/search`,
  API_DISCOVER: `https://${process.env.API_HOST_NAME}/discover`,
  PRODUCT_FEEDS: `https://${process.env.API_HOST_NAME}/product_feed/threads/v2`,
  PRIVACY_POLICY: `http://agreementservice.svs.${process.env.NIKE_DOTCOM_DOMAIN}/:country/:language/rest/agreement?agreementType=privacyPolicy&uxId=:uxId&country=:country&language=:language&requestType=redirect`,
  API_SEO_ANALYSIS_V2: `https://${process.env.API_HOST_NAME}/user_navigation/urlanalysis/v2`,
  API_SEO_GENESIS_V2: `https://${process.env.API_HOST_NAME}/user_navigation/urlgenesis/v2`,
  API_IDENTITY_PROFILE: `https://${process.env.API_HOST_NAME}/identity/user/v1`,
  GLOBAL_CONFIG: `https://${process.env.HOST_NAME}/static/dotcom/shared-config/public/:country/config.json`,

  // Off-platform homepage urls
  AR_HOMEPAGE: 'https://www.nike.com.ar',
  BR_HOMEPAGE: 'https://www.nike.com.br',
  HK_EN_HOMEPAGE: 'https://www.nike.com.hk/?locale=en-gb&intpromo=language2001',
  HK_ZH_HOMEPAGE: 'https://www.nike.com.hk/?locale=zh-hk&intpromo=language1001',
  SA_EN_HOMEPAGE: 'https://www.nike.sa/en/home',
  SA_AR_HOMEPAGE: 'https://www.nike.sa/ar/home',
  AE_EN_HOMEPAGE: 'https://www.nike.ae/en/home',
  AE_AR_HOMEPAGE: 'https://www.nike.ae/ar/home',
  CL_HOMEPAGE: 'https://www.nike.cl',
  CO_HOMEPAGE: 'https://www.nike.com.co',
  PE_HOMEPAGE: 'https://www.nike.com.pe',
  QA_EN_HOMEPAGE: 'https://www.nike.qa/en/home',
  QA_AR_HOMEPAGE: 'https://www.nike.qa/ar/home',
  KW_EN_HOMEPAGE: 'https://www.nike.com.kw/en/home',
  KW_AR_HOMEPAGE: 'https://www.nike.com.kw/ar/home',
  UY_HOMEPAGE: 'https://www.nike.com.uy',
};

export const BODEGA_DEFAULTS = {
  HOME_PAGE: 'Nike Home Page',
  ACCOUNT: 'Account',
  RESOURCES: 'Resources',
  HELP: 'Help',
  BACK_TO: 'Back to {destination}',
  CLEAR: 'Clear',
  CLOSE_MODAL: 'Close Modal',
  CONFIRM: 'Confirm',
  COOKIE_MODAL_ACCEPT: 'Yes, I Accept',
  COOKIE_MODAL_CHECK_FUNCTIONAL_LABEL: 'Functional',
  COOKIE_MODAL_CHECK_FUNCTIONAL_BODY:
    'These cookies are required for basic site functionality and are therefore always enabled. These include cookies that allow you to be remembered as you explore the site within a single session or, if you request, from session to session. They help make the shopping cart and checkout process possible as well as assist in security issues and conforming to regulations.',
  COOKIE_MODAL_CHECK_PERFORMANCE_LABEL: 'Performance',
  COOKIE_MODAL_CHECK_PERFORMANCE_BODY:
    'These cookies allow us to improve the site’s functionality by tracking usage on this website. In some cases these cookies improve the speed with which we can process your request, allow us to remember site preferences you’ve selected. De-selecting these cookies may result in poorly-tailored recommendations and slow site performance.',
  COOKIE_MODAL_CHECK_SOCIAL_AND_ADVERTISING_LABEL: 'Social Media & Advertising',
  COOKIE_MODAL_CHECK_SOCIAL_AND_ADVERTISING_BODY:
    'Social media cookies offer the possibility to connect you to your social networks and share content from our website through social media. Advertising cookies (of third parties) collect information to help better tailor advertising to your interests, both within and beyond Nike websites. In some cases, these cookies involve the processing of your personal data. For more information about this processing of personal data, check our {privacyAndCookiePolicyHTML}. De-selecting these cookies may result in seeing advertising that is not as relevant to you or you not being able to link effectively with Facebook, Twitter, or other social networks and/or not allowing you to share content on social media.',
  COOKIE_MODAL_DONE: 'Done',
  COOKIE_MODAL_FOOTER:
    'You can always change your preference by visiting the "Cookie Settings" at the bottom of the page. View {privacyAndCookiePolicyHTML} for full details.',
  COOKIE_MODAL_MORE_INFO: 'More Information',
  COOKIE_MODAL_POLICY:
    'Nike asks you to accept cookies for performance, social media and advertising purposes. Social media and advertising cookies of third parties are used to offer you social media functionalities and personalized ads. To get more information or amend your preferences, press the ‘more information’ button or visit "Cookie Settings" at the bottom of the website. To get more information about these cookies and the processing of your personal data, check our {privacyAndCookiePolicyHTML}. Do you accept these cookies and the processing of personal data involved?',
  COOKIE_MODAL_PRIVACY_POLICY_LINK: 'Privacy & Cookie Policy',
  COOKIE_MODAL_REJECT: "No, I Don't Accept",
  COOKIE_MODAL_TITLE: 'Your Cookie Settings',
  COMPANY: 'Company',
  CLOSE_MENU: 'Close Menu',
  FIND_A_STORE: 'Find a store',
  HELP_MENU: 'Help Menu',
  JOIN_US_TITLE: 'Join us',
  JOIN_US: 'join us.',
  ALL: 'All',
  FAVORITES: 'Favorites',
  BAG: 'Bag Items',
  ORDERS: 'Orders',
  LEARN_MORE: 'Learn more',
  SIGN_IN: 'Sign In',
  COPY_RIGHTS: 'Nike, Inc. All Rights Reserved',
  POPULAR_SEARCH_TERMS: 'Popular Search Terms',
  TOP_SUGGESTIONS: 'Top Suggestions',
  SEARCH: 'Search',
  SEARCH_PRODUCTS: 'Search Products',
  RESET_SEARCH: 'Reset Search',
  CANCEL: 'Cancel',
  SEARCH_PRODUCT_COUNT_RESULTS: '{filteredProductCount} search results',
  SEARCH_EXTENDED: 'Search Nike and Jordan products',
  KOREAN_MODAL_TITLE: 'Indication under the Contents Industry Promotion Act',
  KOREAN_MODAL_TEXT_1: 'Name of content: product information, event information, etc',
  KOREAN_MODAL_TEXT_2:
    'Date of creation of the content: September 21, 2022 (or its update date if the content has been upgraded)',
  KOREAN_MODAL_TEXT_3:
    'All content in the web page is protected for five years from the date of production or its renewal under the Content Industry Promotion Act (unauthorized copying is prohibited without consent)',
  DONE: 'Done',
  READ_MORE: 'Read More',
  RECENT_SEARCHES: 'Recent Searches',
  RECENTLY_VIEWED: 'Recently Viewed',
  SHOW_PRODUCT_SUGGESTIONS: 'Show Product Suggestions for {selectedSuggestion}',
  MENU: '{menu} menu',
  SELECT_YOUR_LOCATION: 'Select your Location',
  BRAND_NAVIGATION: 'Brand Navigation',
  MAIN_NAVIGATION: 'Main Navigation',
  USER_NAVIGATION: 'User Navigation',
  PLEASE_ENTER_SEARCH_QUERY: 'Please enter a search query',
};

export const PERFORMANCE_KEYS = {
  HEADER_HYDRATION: 'v3HeaderHydration',
  FOOTER_HYDRATION: 'v3FooterHydration',
};

// See NikeShop reference:
// https://github.com/nike-internal/dotcom.cart-favorites-monorepo/tree/master/packages/shop-components#nikeshopevents
export const NIKE_CUSTOM_EVENT = {
  UPDATED_SHARED_SHOP_DATA: '@nikeCustomEvent/updatedSharedShopData',
  UPDATED_CART_COUNT: '@nikeCustomEvent/cartCountUpdated',
};

export const NAV_CUSTOM_EVENTS = {
  MOUNTED: 'NikeDotcomNavMounted',
  OPEN_COOKIE_MODAL: 'NikeDotcomNav_openCookieModal',
  OPEN_LANGUAGE_MENU: 'NikeDotcomNav_geomismatchOpensLanguageMenu',
};

export const MIDDLE_EAST_CLOUD_FRAGMENTS = ['sa/ar', 'ae/ar', 'kw/ar', 'qa/ar'];
export const GEO_SELECTION_QUERY_PARAM = 'geoselection';
// Ignores any URL changes made by offPlatformCountries and URL constant
export const OFF_PLATFORM_OVERRIDE_URL = {
  CN: 'https://www.nike.com.cn/',
  IN: 'https://www.nike.in/',
};
export const CART = 'cart';
export const CHECKOUT = 'checkout';
export const LANDING_PAGE = 'landing page';
export const HOME_PAGE = 'homepage';
export const EDITORIAL = 'editorial';
export const SEO_REDIRECT_URL = 'seo:redirecturl';
export const SIZECHART = 'sizechart';
export const PDP = 'pdp';
export const GRID_WALL = 'gridwall';
export const PDP_GRID_WALL = 'pdpgridwall';
export const SOURCE_ANALYSIS = 'source.analysis';

export const EXPOSED_SEARCH_EXPERIENCES = [CART];
export const MINIMAL_FOOTER_EXPERIENCES = [CHECKOUT];
export const PEEKABOO_HIDDEN_EXPERIENCES = [LANDING_PAGE];

export const PEEKABOO_DISABLED_EXPERIENCES = [HOME_PAGE];
export const PEEKABOO_ENABLED_COUNTRIES = ['MX'];
